import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ParkingGateCodesDashboardQueryKeys } from "modules/ParkingGateCodesDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteParkingGateCodeMutation = () =>
  useTypedMutation({
    mutationFn: async (parking_gate_code_id: number) => (await ApiInstance.post("/parking_gate/code/delete", { parking_gate_code_id }, ENV.dealerBaseURL)).data,
    onSuccess: parking_gate_code_id => {
      const parkingGateCodes = typedQueryClient.getQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes);
      if (!parkingGateCodes) return;

      const parkingGateCodesIdx = parkingGateCodes.findIndex(({ id }) => id === parking_gate_code_id);
      if (parkingGateCodesIdx === -1) return;

      typedQueryClient.setQueryData(ParkingGateCodesDashboardQueryKeys.parkingGateCodes, parkingGateCodes.toSpliced(parkingGateCodesIdx, 1));
    }
  });
